import { ref, onUnmounted, readonly, type Ref } from "vue";

export interface Countdown {
  remaining: Ref<number>;
  start: (seconds: number) => void;
  stop: () => void;
}

export function useCountdown(): Countdown {
  const remaining = ref(0);
  let intervalId: ReturnType<typeof setInterval> | null = null;

  const stop = (): void => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const start = (seconds: number): void => {
    stop();
    remaining.value = Math.max(0, Math.floor(seconds));
    if (remaining.value === 0) {
      return;
    }
    intervalId = setInterval(() => {
      if (remaining.value <= 1) {
        remaining.value = 0;
        stop();
        return;
      }
      remaining.value -= 1;
    }, 1000);
  };

  onUnmounted(stop);

  return {
    remaining: readonly(remaining) as Ref<number>,
    start,
    stop,
  };
}
